import { pipe, dual } from '../../Function/dist/effect-Function.esm.js';
import { forEachSequential, zipRight, flatMap, zip as zip$2 } from '../core.esm.js';
import { scheduleForked } from '../effect/circular.esm.js';
import { make as make$1, value, update, zip as zip$1 } from '../metric.esm.js';
import { retry_Effect } from '../schedule.esm.js';
import { pipeArguments } from '../../Pipeable/dist/effect-Pipeable.esm.js';

/** @internal */
const PollingMetricSymbolKey = "effect/MetricPolling";

/** @internal */
const PollingMetricTypeId = /*#__PURE__*/Symbol.for(PollingMetricSymbolKey);

/** @internal */
const make = (metric, poll) => {
  return {
    [PollingMetricTypeId]: PollingMetricTypeId,
    pipe() {
      return pipeArguments(this, arguments);
    },
    metric,
    poll
  };
};

/** @internal */
const collectAll = iterable => {
  const metrics = Array.from(iterable);
  return {
    [PollingMetricTypeId]: PollingMetricTypeId,
    pipe() {
      return pipeArguments(this, arguments);
    },
    metric: make$1(Array.of(void 0), (inputs, extraTags) => {
      for (let i = 0; i < inputs.length; i++) {
        const pollingMetric = metrics[i];
        const input = pipe(inputs, x => x[i]);
        pollingMetric.metric.unsafeUpdate(input, extraTags);
      }
    }, extraTags => Array.from(metrics.map(pollingMetric => pollingMetric.metric.unsafeValue(extraTags)))),
    poll: forEachSequential(metrics, metric => metric.poll)
  };
};

/** @internal */
const launch = /*#__PURE__*/dual(2, (self, schedule) => pipe(pollAndUpdate(self), zipRight(value(self.metric)), scheduleForked(schedule)));

/** @internal */
const poll = self => self.poll;

/** @internal */
const pollAndUpdate = self => flatMap(self.poll, value => update(self.metric, value));

/** @internal */
const retry = /*#__PURE__*/dual(2, (self, policy) => ({
  [PollingMetricTypeId]: PollingMetricTypeId,
  pipe() {
    return pipeArguments(this, arguments);
  },
  metric: self.metric,
  poll: retry_Effect(self.poll, policy)
}));

/** @internal */
const zip = /*#__PURE__*/dual(2, (self, that) => ({
  [PollingMetricTypeId]: PollingMetricTypeId,
  pipe() {
    return pipeArguments(this, arguments);
  },
  metric: pipe(self.metric, zip$1(that.metric)),
  poll: zip$2(self.poll, that.poll)
}));

export { PollingMetricTypeId, collectAll, launch, make, poll, pollAndUpdate, retry, zip };
